import { useEffect, useState } from "react";
import WaitlistForm from "@/components/site/WaitlistForm";
import ShareRow from "@/components/site/ShareRow";
import { getWaitlistCount } from "@/lib/api";

export const Hero = () => {
  const [count, setCount] = useState(null);

  useEffect(() => {
    getWaitlistCount()
      .then((d) => setCount(d.count))
      .catch(() => setCount(null));
  }, []);

  return (
    <section
      id="top"
      data-testid="hero-section"
      className="relative min-h-screen pt-32 sm:pt-40 pb-28 sm:pb-32 overflow-hidden"
    >
      {/* Ambient ornaments — hidden on mobile (large blur ornaments are
          expensive to composite on iOS Safari during scroll and offer
          little visual value on small screens). */}
      <div className="hidden md:block absolute -top-20 -left-20 w-[420px] h-[420px] rounded-lg bg-[#5B9EC9]/5 blur-3xl pointer-events-none" />
      <div className="hidden md:block absolute top-1/3 -right-32 w-[520px] h-[520px] rounded-full bg-[var(--w-input-bg)]/40 blur-3xl pointer-events-none" />

      <div className="max-w-3xl mx-auto px-6 md:px-10 flex flex-col items-center text-center">
        {/* Top status row */}
        <div
          className="reveal flex items-center gap-3 mb-10"
          style={{ animationDelay: "60ms" }}
        >
          <span className="relative flex h-2 w-2">
            <span className="absolute inline-flex h-full w-full animate-ping rounded-lg bg-[#22C55E]/60" />
            <span className="relative inline-flex h-2 w-2 rounded-lg bg-[#22C55E]" />
          </span>
          <span className="label-overline" data-testid="hero-status-label">
            Private alpha — Now live
          </span>
        </div>

        {/* Title */}
        <h1
          data-testid="hero-heading"
          className="reveal font-serif-display text-pearl tracking-tight leading-[1.05] text-[32px] sm:text-5xl lg:text-6xl"
          style={{ animationDelay: "160ms" }}
        >
          Reserve your <span className="italic text-bone">@w.xyz</span> address for the next Wave in email.
        </h1>

        {/* Waitlist form — the primary CTA */}
        <div
          className="reveal w-full max-w-md mt-10 text-left"
          style={{ animationDelay: "300ms" }}
          id="reserve"
        >
          <WaitlistForm id="waitlist-form-hero" />

          <div className="mt-6 flex justify-center">
            <ShareRow context="hero" overline="Spread the word" />
          </div>
        </div>

        {count !== null && count >= 1000 && (
          <div
            className="reveal mt-14"
            style={{ animationDelay: "440ms" }}
          >
            <span className="label-overline" data-testid="hero-waitlist-count">
              {count.toLocaleString()} on the list
            </span>
          </div>
        )}
      </div>
    </section>
  );
};

export default Hero;
